export default "__VITE_ASSET__CiY_YeoK__"